import { useNavigate } from "react-router-dom"
import { useSelectedCompany } from "../../context/companyProvider"
import ChangeCompanyButton from "./ChangeCompanyButton"

export default function CompanyChangeAction() {
  const { isAdmin, hasSelectedCompany, clearCompany } = useSelectedCompany()
  const navigate = useNavigate()

  if (!isAdmin || !hasSelectedCompany) return null

  return (
    <ChangeCompanyButton
      onClick={() => {
        clearCompany()
        navigate("/app/management-companies")
      }}
    />
  )
}
